import CampaignList from './CampaignList.vue';

export { CampaignList };

export default {
  CampaignList,
};
